import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Cookies from "js-cookie";

const NOTIFICATION_KEYS = [
  { key: "profile_enrichment", label: "Profile Enrichment" },
  { key: "individual_message", label: "Individual Message" },
  { key: "group_message", label: "Group Message" },
  { key: "contact_joined", label: "Contact Joined/Added" },
];

export const NotificationPage = () => {
  const token = Cookies.get("auth_token");

  const [settings, setSettings] = useState({
    profile_enrichment: 0,
    individual_message: 0,
    group_message: 0,
    contact_joined: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/settings/get`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.status === "1" && Array.isArray(data.data) && data.data[0]) {
          setSettings({
            profile_enrichment: Number(data.data[0].profile_enrichment) || 0,
            individual_message: Number(data.data[0].individual_message) || 0,
            group_message: Number(data.data[0].group_message) || 0,
            contact_joined: Number(data.data[0].contact_joined) || 0,
          });
        } else {
          toast.error(data.message || "Failed to load settings");
        }
      } catch (err) {
        toast.error(err.message || "Failed to load settings");
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [token]);

  const toggleSetting = async (key) => {
    const nextValue = settings[key] === 1 ? 0 : 1;
    setSettings((prev) => ({ ...prev, [key]: nextValue }));

    try {
      const formData = new FormData();
      formData.append("notification_type", key);
      formData.append("value", nextValue);

      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/settings/toggle`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();
      if (data.status !== "1") {
        toast.error(data.message || "Failed to update");
        // revert on failure
        setSettings((prev) => ({ ...prev, [key]: settings[key] }));
      } else {
        toast.success("Notification setting updated");
      }
    } catch (err) {
      toast.error(err.message || "Failed to update");
      setSettings((prev) => ({ ...prev, [key]: settings[key] }));
    }
  };

  const Toggle = ({ checked, onChange }) => (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
      />
      <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:bg-[#6938EF] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:after:translate-x-[16px]" />
    </label>
  );

  return (
    <div className="rounded-2xl p-5 md:p-6 border border-gray-100 shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Notificat</h2>
      </div>

      <div className="space-y-4 h-[80dvh] overflow-y-auto py-2">
        {loading ? (
          <div className="space-y-3">
            {Array.from({ length: 4 }).map((_, idx) => (
              <div key={idx} className="h-16 rounded-2xl bg-gray-200 animate-pulse" />
            ))}
          </div>
        ) : (
          NOTIFICATION_KEYS.map(({ key, label }) => (
            <div
              key={key}
              className="relative rounded-2xl border border-gray-200 p-6 shadow-[1px_4px_4px_0_rgba(122,90,248,0.12)] bg-[#F7F8F8]"
            >
              <div className="flex items-center justify-between">
                <span className="block text-lg font-semibold text-black">{label}</span>
                <Toggle
                  checked={settings[key] === 1}
                  onChange={() => toggleSetting(key)}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
